export default "__VITE_ASSET__DbFNVDh6__"